import React from 'react';
import { Person } from 'talent_matching/types';
import { withLocalePrefix } from 'shared/utils/translation';
import { useTalentMatchingTabContext } from 'talent_matching/contexts/talent_matching_tab_context';
import {
  MenuItem,
  MenuList,
} from '@grnhse/seedling/lib/birch/components/expandable_menu';
import { Tooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import { useRowActionsModal } from 'talent_matching/contexts/row_actions_modal_context';
import useAdvanceCandidate from 'talent_matching/hooks/use_advance_candidate';
import LazyEllipsisMenu from 'talent_matching/components/shared/lazy_ellipsis_menu';

const t = withLocalePrefix('talent_matching');

type Props = {
  candidate: Person;
};

export const CandidateRowActions = ({ candidate }: Props) => {
  const { canAdvance, feedbackOnly, canReject } = useTalentMatchingTabContext();
  const { openFeedbackFor, openRejectFor } = useRowActionsModal();
  const advanceCandidate = useAdvanceCandidate('table_row');

  const handleAdvance = () => {
    advanceCandidate(candidate);
  };

  return (
    <LazyEllipsisMenu ariaLabel={t('table.labels.actions')}>
      <MenuList>
        <MenuItem onSelect={() => openFeedbackFor(candidate)}>
          {t('table.labels.feedback')}
        </MenuItem>
        {!feedbackOnly && (
          <>
            {canReject ? (
              <MenuItem onSelect={() => openRejectFor(candidate, 'table_row')}>
                {t('reject')}
              </MenuItem>
            ) : (
              <Tooltip
                label={t('table.tooltips.cannot_reject')}
                ariaLabel={t('table.tooltips.cannot_reject')}
              >
                <MenuItem
                  onSelect={() => openRejectFor(candidate, 'table_row')}
                  disabled={true}
                >
                  {t('reject')}
                </MenuItem>
              </Tooltip>
            )}
            {canAdvance ? (
              <MenuItem onSelect={handleAdvance}>
                {t('table.labels.advance')}
              </MenuItem>
            ) : (
              <Tooltip
                label={t('table.tooltips.cannot_advance')}
                ariaLabel={t('table.tooltips.cannot_advance')}
              >
                <MenuItem onSelect={handleAdvance} disabled={true}>
                  {t('table.labels.advance')}
                </MenuItem>
              </Tooltip>
            )}
          </>
        )}
      </MenuList>
    </LazyEllipsisMenu>
  );
};

export default CandidateRowActions;
